import React, { FC } from 'react';
import Select, { MultiValue, SingleValue } from 'react-select';

interface DropdownSelectProps {
  isMulti?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  isSearchable?: boolean;
  placeholder?: string;
  styles?: any;
  filterOption?: any;
  formatOptionLabel?: any;
  menuPortalTarget?: HTMLElement | null;
  menuPosition?: 'absolute' | 'fixed';
  options: IDropdownSelectOptionItem[];
  value: SingleValue<IDropdownSelectOptionItem> | MultiValue<IDropdownSelectOptionItem> | null;
  onChange: (data: any, state: any) => void;
}

const defaultStyles = {
  control: (provided: any) => ({
    ...provided,
    minHeight: '40px',
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: '0 8px',
  }),
  input: (provided: any) => ({
    ...provided,
    margin: '0',
    padding: '0',
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    minHeight: '40px',
  }),
  menuList: (provided: any) => ({
    ...provided,
    maxHeight: '200px',
    overflowY: 'auto',
  }),
};

export const DropdownSelect: FC<DropdownSelectProps> = ({
  options,
  value,
  onChange,
  placeholder,
  styles = defaultStyles,
  isDisabled = false,
  isLoading = false,
  isMulti = false,
  isSearchable = true,
  filterOption,
  formatOptionLabel,
  menuPortalTarget,
  menuPosition,
}) => {
  return (
    <Select
      options={options}
      onChange={onChange}
      value={value}
      styles={styles}
      isMulti={isMulti}
      isLoading={isLoading}
      isSearchable={isSearchable}
      placeholder={placeholder}
      filterOption={filterOption}
      formatOptionLabel={formatOptionLabel}
      isDisabled={isDisabled || isLoading}
      menuPortalTarget={menuPortalTarget}
      menuPosition={menuPosition}
    />
  );
};
